import { render, staticRenderFns } from "./CadastroProposta.vue?vue&type=template&id=4c0fdff2"
import script from "./CadastroProposta.vue?vue&type=script&lang=js"
export * from "./CadastroProposta.vue?vue&type=script&lang=js"
import style0 from "@core/scss/vue/libs/quill.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./CadastroProposta.vue?vue&type=style&index=1&id=4c0fdff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports